import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 21A2819F-3B97-49D0-A588-30CF7B8915F5
 * name details
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/details.svg
 * tags
 */
export const DetailsIcon = createSvgIcon(<><path d="M6.38,6H17.63L12,16L6.38,6M3,4L12,20L21,4H3Z" /></>, 'DetailsIcon');
export default DetailsIcon